import { TableCell } from "@mui/material";
import { useState } from "react";
import { IAddressBookListItem } from "../../Interfaces/addressbook";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../Tables/TableTemplate/tableTemplate";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteAddressBooks } from "../../Requests/addressbook";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../Utils/requestUtils";

const AdditionalHeader = ({
  selectedRowsIds,
  setSelectedRowsIds,
  onAction,
}: IAdditionalHeaderProps) => {
  const bulkDeleteHandler = () => {
    if (!selectedRowsIds || !selectedRowsIds.length) return;
    deleteAddressBooks(selectedRowsIds)
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          onAction();
          setSelectedRowsIds([]);
        }
      })
      .catch(packetErrorHandler);
  };

  return (
    <>
      <TableCell>
        <div
          className="hover:bg-red-100 transition-all rounded p-1"
          onClick={selectedRowsIds.length ? bulkDeleteHandler : undefined}
        >
          <DeleteIcon
            fontSize="small"
            className={`cursor-pointer ${
              selectedRowsIds.length ? "text-red-900 " : "text-gray-300"
            } transition-all`}
          />
        </div>
      </TableCell>
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IAddressBookListItem;
  onAction: () => void;
}> = ({ row, onAction }) => {
  console.log({ row });
  const deleteHandler = (id: number) => {
    deleteAddressBooks([id])
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          onAction();
        }
      })
      .catch(packetErrorHandler);
  };
  return (
    <>
      <TableCell>
        <div
          onClick={() => deleteHandler(row.id)}
          className="hover:bg-red-100 transition-all rounded p-1"
        >
          <DeleteIcon
            fontSize="small"
            className="text-red-700 cursor-pointer"
          />
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IAddressBookListItem> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
